import React, { ChangeEvent, FC, ReactElement, useState } from "react"

export type CheckBoxRenderer = (properties: CheckBoxProps) => ReactElement;

export interface ICheckBox extends CheckBoxProps{
    renderer?: CheckBoxRenderer
}

export interface CheckBoxProps {
    id: string;
    value: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    label?: string;
    name?: string;
    disabled?: boolean;
    size?: "small" | "medium";
}

export const CheckBox : FC<ICheckBox> = ({id, value, label, name, disabled, onChange : onOutterChange, size, renderer}) => {

    const [innerValue, setInnerValue] = useState(value)

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        setInnerValue(event.target.checked)
        onOutterChange && onOutterChange(event);
    }

    return renderer ? renderer({id, value: innerValue, label, name, disabled, onChange, size}) : <>{label}<input id={id} type="checkbox" name={name ?? ""} disabled={disabled ?? false} checked={innerValue} onChange={onChange} /></>
}  